import { render, staticRenderFns } from "./query-batch.vue?vue&type=template&id=ef1b58c2&scoped=true&"
import script from "./query-batch.vue?vue&type=script&lang=js&"
export * from "./query-batch.vue?vue&type=script&lang=js&"
import style0 from "./query-batch.vue?vue&type=style&index=0&id=ef1b58c2&scoped=true&lang=less&"
import style1 from "./query-batch.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1b58c2",
  null
  
)

export default component.exports